'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFXfavoriteFundsUrl = exports.buildFundIdentifier = exports.setUrlHashParameter = exports.getUrlHashParameter = exports.getPDPUrl = exports.isMobileInsight = exports.isMobile = exports.indetifyAppType = exports.setNewPDPLocation = exports.setNewLocation = exports.goTo = exports.setTargetWindowObject = undefined;

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationService = {
  setTargetWindowObject: function setTargetWindowObject(targetWindowObject) {
    if ((0, _ramda.isNil)(targetWindowObject)) {
      return false;
    }
    this.targetWindowObject = targetWindowObject;
  },
  goTo: function goTo(url, target) {
    if (!(0, _ramda.isNil)(target)) {
      this.targetWindowObject.open(url, target);
    } else {
      this.targetWindowObject.location = url;
    }
  },
  setNewLocation: function setNewLocation(cusip, shareclassName, basePath, retainHashParameter) {
    var appType = this.identifyAppType(basePath);
    basePath += _constants2.default.getBasePathSuffix(appType);
    var basePathRegEx = new RegExp('/' + basePath + '(.*?)(/|$)');
    var replaceBy = '/' + basePath + this.buildFundIdentifier(shareclassName, cusip);
    if (!basePathRegEx.test(this.targetWindowObject.location.pathname)) {
      basePath = _constants2.default.getBasePathSuffix(appType);
      basePathRegEx = new RegExp(basePath + '(.*?)(/|$)');
      replaceBy = basePath + this.buildFundIdentifier(shareclassName, cusip);
    }

    this.redirectWithBasePathRegex(basePathRegEx, replaceBy, retainHashParameter);
  },
  setAEMNewLocation: function setAEMNewLocation(cusip, shareclassName, retainHashParameter) {
    var basePath = '/products/';
    var basePathRegEx = new RegExp(basePath + '(.*?)(/|$)');
    var replaceBy = basePath + this.buildFundIdentifier(shareclassName, cusip);
    this.redirectWithBasePathRegex(basePathRegEx, replaceBy, retainHashParameter);
  },
  redirectWithBasePathRegex: function redirectWithBasePathRegex(basePathRegex, replaceBy, retainHashParameter) {
    if (!retainHashParameter) {
      this.targetWindowObject.location.hash = "";
    }
    this.targetWindowObject.location.pathname = this.targetWindowObject.location.pathname.replace(basePathRegex, replaceBy);
  },
  setNewPDPLocation: function setNewPDPLocation(url) {
    this.targetWindowObject.location.pathname = url;
  },
  identifyAppType: function identifyAppType(basePath) {
    var currentURL = this.targetWindowObject.location.pathname;
    var mobilePathSuffixList = _constants2.default.getMobilePathSuffix();
    var appType = "/d/";
    mobilePathSuffixList.map(function (suffix) {
      if (currentURL.indexOf(basePath + suffix) !== -1) {
        appType = suffix;
      }
    });
    return appType;
  },
  isMobile: function isMobile(basePath) {
    return !(0, _ramda.isNil)(basePath) && this.isPresentInPath(basePath, _constants2.default.getMobilePathSuffix());
  },
  isMobileInsight: function isMobileInsight(basePath) {
    if (this.targetWindowObject.location) {
      return this.isPresentInHref(_constants2.default.getMobileInsightPathQueryString()) || !(0, _ramda.isNil)(basePath) && this.isPresentInPath(basePath, _constants2.default.getMobileInsightPathSuffix());
    }
    return false;
  },
  isPresentInPath: function isPresentInPath(basePath, list) {
    var currentURL = this.targetWindowObject.location.pathname;
    var isMobileInsight = false;
    list.map(function (suffix) {
      if (currentURL.indexOf(basePath + suffix) !== -1) {
        isMobileInsight = true;
      }
    });
    return isMobileInsight;
  },
  isPresentInHref: function isPresentInHref(list) {
    var currentHref = this.targetWindowObject.location.href;
    var isMobileInsight = false;
    list.map(function (suffix) {
      if (!(0, _ramda.isNil)(currentHref) && currentHref.toLowerCase().indexOf(suffix.toLowerCase()) !== -1) {
        isMobileInsight = true;
      }
    });
    return isMobileInsight;
  },
  isAuthorUrl: function isAuthorUrl() {
    var currentHref = this.targetWindowObject.location.href;
    var isAuthorUrl = false;
    _constants.AUTHOR_URL_SUFFIX.map(function (suffix) {
      if (!(0, _ramda.isNil)(_constants.AUTHOR_URL_SUFFIX) && currentHref.toLowerCase().startsWith(suffix.toLowerCase())) {
        isAuthorUrl = true;
      }
    });
    return isAuthorUrl;
  },
  getPDPUrl: function getPDPUrl(basePath, identifier, role, parent, pdpPath) {
    var originURL = this.targetWindowObject.location.origin;
    var currentHref = this.targetWindowObject.location.href;

    if (!(0, _ramda.isNil)(parent) && parent === _constants2.default.getAEMParentString() && !(0, _ramda.isNil)(pdpPath)) {
      var url = '' + originURL + pdpPath + identifier;
      if (!(0, _ramda.isNil)(role) && role === _constants2.default.getNy529Role() && this.targetWindowObject.location.pathname.indexOf('/' + role + '/') === -1) {
        url = originURL + '/products/' + identifier;
      } else if (!(0, _ramda.isNil)(currentHref) && this.isPresentInHref(_constants2.default.getMobileInsightPathQueryString())) {
        var queryString = "?" + _constants2.default.getMobileInsightPathQueryString()[0];
        url += queryString;
      }
      return url;
    }

    var currentURL = this.targetWindowObject.location.pathname;
    var appType = this.identifyAppType(basePath);
    basePath += _constants2.default.getBasePathSuffix(appType);

    if (!(0, _ramda.isNil)(currentURL) && currentURL.indexOf("/gim/protected/" + role) !== -1) {
      var basePathRegEx = new RegExp('/gim/protected/' + role + '/.*');
      currentURL = currentURL.replace(basePathRegEx, '/gim/protected/' + role + "/" + basePath + identifier);
    } else if (!(0, _ramda.isNil)(role) && role === _constants2.default.getNy529Role()) {
      currentURL = "/" + basePath + identifier;
    } else if (currentURL.indexOf("/gim/" + role) !== -1) {
      var _basePathRegEx = new RegExp('/gim/' + role + '/.*');
      currentURL = currentURL.replace(_basePathRegEx, '/gim/' + role + "/" + basePath + identifier);
    } else {
      var _basePathRegEx2 = new RegExp(role + '/.*');
      currentURL = currentURL.replace(_basePathRegEx2, role + "/" + basePath + identifier);
    }
    return currentURL;
  },
  getFXfavoriteFundsUrl: function getFXfavoriteFundsUrl(filteredFundType, noFavoriteFunds, role) {
    var favoriteFundsRegEx = new RegExp('/' + role + '.*');
    var fundExplorerUrl = this.targetWindowObject.location.pathname.replace(favoriteFundsRegEx, "") + '/' + role + '/products/fund-explorer/' + filteredFundType;
    if (noFavoriteFunds) {
      return fundExplorerUrl;
    }
    return fundExplorerUrl + '/favorite_funds';
  },
  getUrlHashParameter: function getUrlHashParameter() {
    var hashParameter = this.targetWindowObject.location.hash.replace("#/", "").replace("#", "");
    if (hashParameter.indexOf("/") > -1) {
      hashParameter = hashParameter.substring(0, hashParameter.indexOf("/"));
    }
    return hashParameter;
  },
  getNavigateToCardParameter: function getNavigateToCardParameter() {
    var cardParameter = null;
    var navigateToCardParameter = this.targetWindowObject.location.hash.replace("#/", "");
    if (navigateToCardParameter.indexOf("/") > -1) {
      navigateToCardParameter = navigateToCardParameter.substring(navigateToCardParameter.indexOf("/"));
      cardParameter = navigateToCardParameter.replace("/", "");
      if (cardParameter === "") {
        cardParameter = null;
      }
    }
    return cardParameter;
  },
  setUrlHashParameter: function setUrlHashParameter(hash) {
    this.targetWindowObject.location.hash = '#/' + hash;
  },
  buildFundIdentifier: function buildFundIdentifier(shareclassName, cusip) {
    if (!(0, _ramda.isNil)(cusip)) {
      return _string_utility2.default.customKebabCase(shareclassName + "-") + cusip.toLowerCase();
    } else {
      return _string_utility2.default.customKebabCase(shareclassName + "-") + cusip;
    }
  }
};

exports.default = LocationService;
var setTargetWindowObject = LocationService.setTargetWindowObject,
    goTo = LocationService.goTo,
    setNewLocation = LocationService.setNewLocation,
    setNewPDPLocation = LocationService.setNewPDPLocation,
    indetifyAppType = LocationService.indetifyAppType,
    isMobile = LocationService.isMobile,
    isMobileInsight = LocationService.isMobileInsight,
    getPDPUrl = LocationService.getPDPUrl,
    getUrlHashParameter = LocationService.getUrlHashParameter,
    setUrlHashParameter = LocationService.setUrlHashParameter,
    buildFundIdentifier = LocationService.buildFundIdentifier,
    getFXfavoriteFundsUrl = LocationService.getFXfavoriteFundsUrl;
exports.setTargetWindowObject = setTargetWindowObject;
exports.goTo = goTo;
exports.setNewLocation = setNewLocation;
exports.setNewPDPLocation = setNewPDPLocation;
exports.indetifyAppType = indetifyAppType;
exports.isMobile = isMobile;
exports.isMobileInsight = isMobileInsight;
exports.getPDPUrl = getPDPUrl;
exports.getUrlHashParameter = getUrlHashParameter;
exports.setUrlHashParameter = setUrlHashParameter;
exports.buildFundIdentifier = buildFundIdentifier;
exports.getFXfavoriteFundsUrl = getFXfavoriteFundsUrl;